import React from "react";
import {Card, Select} from "antd";
import {BillCredit} from "./popups/BillCredit";
import {AccountHotsheet} from "./popups/AccountHotsheet";
import {DispatchHistory} from "./popups/DispatchHistory";
import {Contracts} from "./popups/Contracts";
import {ProposalAccount} from "./popups/ProposalAccount";
import {ProjectLogAccount} from "./popups/ProjectLogAccount";
import {Attachments} from "./popups/Attachments";
import {BillToGet, BillToList} from "../../models/billto";
import {WorkOrderTable} from "../tracks/workorder/WorkOrderTable";

const Option = Select.Option;
const _ = require('lodash');

export class BillTo extends React.Component {
  state = {
    visible: false,
    showBillCredit: false,
    visibleDispatch: false,
    visibleHotsheet: false,
    showAddWorkOrder: false,
    visibleContracts: false,
    visibleProposal: false,
    visibleProjectLog: false,
    selectedBillToData: {},
    data:[]
  }

   fetchBillTo = (params = {}) => {
    this.setState({loading: true, params});
    BillToList(params)
      .then(response => {
        this.setState({
          loading: false,
          data: response.data.results,
        });
      });
  }

  selectedBillTo=(value)=>{
    BillToGet(value.key)
      .then(response => {
        this.setState({
          selectedBillToData: response.data
        });
        this.workorder.fetch({'bill_to__id': response.data.id})
      })
  }
  onChangeBillTo = (billto) => {
    this.setState({billto})
  }

  showBillCreditModal = (visible) => {
    this.setState({showBillCredit: visible})
  }
  showDispatchHistory = (visible) => {
    this.setState({visibleDispatch: visible})
  }
  showHotsheet = (visible) => {
    this.setState({visibleHotsheet: visible})
  }

  render() {
    const {data, loading, selectedBillToData, billto} = this.state;
    return (
      <div id="main-content">
        <div className="container-fluid">
          <div className="block-header">
            <div className="row clearfix">
              <div className="col-sm-4 col-12">
                <h3 className="main-heading">AB Accounts</h3>
              </div>
              <div className="col-sm-8 col-12">
              </div>
            </div>
            <div className="row clearfix m-t-15">
              <div className="col-12 m-b-20 full-select-search">
                <Select
                  showSearch
                  style={{width: "100%"}}
                  placeholder="Bill To"
                  optionFilterProp="children"
                  onSelect={this.selectedBillTo} mode="default" labelInValue value={billto}
                  onFocus={this.fetchBillTo} onChange={this.onChangeBillTo}
                  onSearch={(value) => this.fetchBillTo({search: value})} loading={loading}>
                  {data.map(d => (<Option key={d.id}>{d.account_number} | {d.company_name}</Option>))}
                </Select>
              </div>
              <div className="col-12">
                <h3 className="main-heading">Bill To Information</h3>
              </div>
            </div>
            <div className="row clearfix margin-0">
              <div className="col-sm-9 col-xs-120">
                {_.isEmpty(selectedBillToData) ?
                  <div className="row clearfix main-card">
                    <p className="no-data">No Bill To Selected</p>
                  </div> :
                  <div className="row clearfix main-card">
                    <div className="col-sm-3 col-12">
                      <Card
                      title="Name"
                      extra={<a href="#"><i className="fa fa-info"> </i> </a>}
                      style={{width: "100%"}}
                      bordered={false}>
                      <h4>{selectedBillToData.company_name}</h4>
                    </Card>
                  </div>
                  <div className="col-sm-3 col-12">
                    <Card
                      title="Email"
                      extra={<a href="#"><i className="fa fa-info"> </i> </a>}
                      style={{width: "100%"}}
                      bordered={false}>
                      <h4>{selectedBillToData.email}</h4>
                    </Card>
                  </div>
                  <div className="col-sm-3 col-12">
                    <Card
                      title="Address"
                      extra={<a href="#"><i className="fa fa-info"> </i> </a>}
                      style={{width: "100%"}}
                      bordered={false}>
                      <h4>{selectedBillToData.address}</h4>
                    </Card>
                  </div>
                  <div className="col-sm-3 col-12">
                    <Card
                      title="City"
                      extra={<a href="#"><i className="fa fa-info"> </i> </a>}
                      style={{width: "100%"}}
                      bordered={false}>
                      <h4>{selectedBillToData.city}</h4>
                    </Card>
                  </div>
                  <div className="col-sm-3 col-12">
                    <Card
                      title="State"
                      extra={<a href="#"><i className="fa fa-info"> </i> </a>}
                      style={{width: "100%"}}
                      bordered={false}>
                      <h4>{selectedBillToData.state}</h4>
                    </Card>
                  </div>
                  <div className="col-sm-3 col-12">
                    <Card
                      title="ZIP Code"
                      extra={<a href="#"><i className="fa fa-info"> </i> </a>}
                      style={{width: "100%"}}
                      bordered={false}>
                      <h4>{selectedBillToData.zip_code}</h4>
                    </Card>
                  </div>
                  <div className="col-sm-3 col-12">
                    <Card
                      title="Phone"
                      extra={<a href="#"><i className="fa fa-info"> </i> </a>}
                      style={{width: "100%"}}
                      bordered={false}>
                      <h4>{selectedBillToData.phone}</h4>
                    </Card>
                  </div>
                  <div className="col-sm-3 col-12">
                    <Card
                      title="Contact"
                      extra={<a href="#"><i className="fa fa-info"> </i> </a>}
                      style={{width: "100%"}}
                      bordered={false}>
                      <h4>{selectedBillToData.contact}</h4>
                    </Card>
                  </div>
                  <div className="col-sm-3 col-12">
                    <Card
                      title="Payment Term"
                      extra={<a href="#"><i className="fa fa-info"> </i> </a>}
                      style={{width: "100%"}}
                      bordered={false}>
                      <div className="col-12 padding-0 multiple-enrty">
                        <h4>Net 30</h4>
                      </div>
                    </Card>
                  </div>
                  <div className="col-sm-3 col-12">
                    <Card
                      title="Payment Status"
                      extra={<a href="#"><i className="fa fa-info"> </i> </a>}
                      style={{width: "100%"}}
                      bordered={false}>
                      <div className="col-12 padding-0 multiple-enrty">
                        <h4>Satisfactory</h4>
                      </div>
                    </Card>
                  </div>
                  <div className="col-sm-3 col-12">
                    <Card
                      title="Notes"
                      extra={<a href="#"><i className="fa fa-info"> </i> </a>}
                      style={{width: "100%"}}
                      bordered={false}>
                      <div className="col-12 padding-0 multiple-enrty">
                        <h4>Lorem Ipsum Dolar AMaet</h4>
                      </div>
                    </Card>
                  </div>
                  <div className="col-sm-3 col-12">
                    <Card
                      title="Revenue"
                      extra={<a href="#"><i className="fa fa-info"> </i> </a>}
                      style={{width: "100%"}}
                      bordered={false}>
                      <div className="col-12 padding-0 multiple-enrty">
                        <p><a>$10,345.56</a></p>
                      </div>
                    </Card>
                  </div>
                  <div className="col-sm-3 col-12">
                    <Card
                      title="Associated Generator"
                      extra={<a href="#"><i className="fa fa-info"> </i> </a>}
                      style={{width: "100%"}}
                      bordered={false}>
                      <div className="col-12 padding-0 multiple-enrty">
                        <h4>Con Anderson</h4>
                      </div>
                    </Card>
                  </div>
                  <div className="col-sm-3 col-12">
                    <Card
                      title="Last Service Date"
                      extra={<a href="#"><i className="fa fa-info"> </i> </a>}
                      style={{width: "100%"}}
                      bordered={false}>
                      <div className="col-12 padding-0 multiple-enrty">
                        <h4>2019-02-07</h4>
                      </div>
                    </Card>
                  </div>
                </div>}
              </div>
              <div className="col-sm-3 col-xs-12 paddingZ-xs p-r-0">
                <div className="job-details-bar">
                  <h4>Tracking Tools</h4>
                  <ul>
                    <li><a href="#">Billing & Credit</a></li>
                    <li><a href="#">Files & Attachments</a></li>
                    <li><a href="#">Dispatch History</a></li>
                    <li><a href="#">Contracts</a></li>
                    <li><a href="#">Quotes/Proposals</a></li>
                    <li><a href="#">Work Orders</a></li>
                    <li><a href="#">Client Projects Log</a></li>
                    <li><a href="#">Hotsheets</a></li>
                  </ul>
                </div>
              </div>
            </div>
            <WorkOrderTable onRef={ref => (this.workorder = ref)} advanceFilter={false}/>
            <BillCredit visible={this.state.showBillCredit} onCancel={() => this.showBillCreditModal(false)}/>
            <DispatchHistory visible={this.state.visibleDispatch} onCancel={() => this.showDispatchHistory(false)}/>
            <AccountHotsheet visible={this.state.visibleHotsheet} onCancel={() => this.showHotsheet(false)}/>
            <Contracts visible={this.state.visibleContracts} onCancel={() => this.showContracts(false)}/>
            <ProposalAccount visible={this.state.visibleProposal} onCancel={() => this.showVisibleProposal(false)}/>
            <ProjectLogAccount visible={this.state.visibleProjectLog}
                               onCancel={() => this.showVisibleProjectLog(false)}/>
            <Attachments visible={this.state.visibleAttachment} onCancel={() => this.showAttachment(false)}/>
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/account/BillTo.jsx